import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvService } from './env.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Guid } from 'guid-typescript';
import { saveAs } from 'file-saver';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RestService {
  constructor(private http: HttpClient, private envService: EnvService) {}
  private CUSTOMER_ID = sessionStorage.getItem('customer');
  private AGENCY_ID = sessionStorage.getItem('agency');
  private Customer = new BehaviorSubject<string>(this.CUSTOMER_ID);
  private Agency = new BehaviorSubject<string>(this.AGENCY_ID);
  private UserReady = new BehaviorSubject<boolean>(false);
  private isSuperAdmin = new BehaviorSubject<boolean>(false);
  private defaultDistanceUnit = new BehaviorSubject<string>('Foot');
  private MSIProduct = 'PHZ' // need to be passed while calling Verify/Geocoding Endpoints
  private ForStorage = true; // need to be passed while calling Verify/Geocoding Endpoints
  private CCAdminVersion = this.envService.admin;
  // for sharing agency infomation between different components
  currentAgency = this.Agency.asObservable();
  currCustomer = this.Customer.asObservable();
  Ready = this.UserReady.asObservable();
  isCCAdminSuperAdmin = this.isSuperAdmin.asObservable();
  DefaultDistanceUnit = this.defaultDistanceUnit.asObservable();
  // private messageSource = new BehaviorSubject("default message");
  // currentMessage = this.messageSource.asObservable();
  env1 = this.envService.env1;
  env = this.envService.env;
  env2 = this.envService.env2;
  domainExtension = this.envService.domainExtension;
  // tslint:disable-next-line:variable-name
  Jwthelper = new JwtHelperService(); // use for checking the access_token is expired or not
  localGeobaseURL = 'http://localhost:5000/admin/v1/'; // for local testing
  geobaseURL = `https://coregis${this.env1}commandcentral.${this.domainExtension}/admin/v1/`;
  getMeurl = `https://admin-api${this.env}commandcentral.${this.domainExtension}/api/admin/me`;
  getMeurl2 = `https://admin-api${this.env}commandcentral.${this.domainExtension}/api/admin-v2/me?with-relations=ALL`;
  // tslint:disable-next-line:variable-name
  _serverBaseUrl = `https://coregis${this.env1}commandcentral.${this.domainExtension}/geoverification/v1`; // geobaseUrl
  getagenciesurl = `https://admin-api${this.env}commandcentral.${this.domainExtension}/api/admin/customers`;
  unitConvert = new Map()
    .set('Foot', 1 / 3.2808)
    .set('Mile', 1609.34)
    .set('Kilometers', 1000)
    .set('Meter', 1);
  changeAgency(item: string) {
    this.Agency.next(item);
  }
  changeCustomer(item: string) {
    this.Customer.next(item);
  }
  changeUserStatus(item: boolean) {
    this.UserReady.next(item);
  }
  CheckIfIsSuperAdmin(item: boolean) {
    this.isSuperAdmin.next(item);
  }
  changeDefaultDistanceUnit(item: string) {
    this.defaultDistanceUnit.next(item);
  }

  public get_typeproximityschema(CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.get<any>(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type/', opt);
  }

  public getMe() {
    // const opt = {
    //   headers: new HttpHeaders({
    //     Authorization:this.testToken
    //   })
    // };
    if(this.CCAdminVersion === 'admin2.')
    {
      console.log('Calling ' + this.getMeurl2);
      return this.http.get<any>(this.getMeurl2);
    }
    else
    {
      console.log('Calling ' + this.getMeurl);
      return this.http.get<any>(this.getMeurl);
    }
  }

  public delete_phzreocrd(schema) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.delete(
      this.geobaseURL + schema.CustomerId + '/' + schema.AgencyId + '/Phz/record/' + schema.PremiseHazardInfoKey,
      opt
    );
  }

  public create_Type(createSchema, CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization:this.testToken
    });
    return this.http.post(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type/', createSchema, {
      headers,
      observe: 'response',
      responseType: 'text',
    });
  }
  update_Type(updateSchema, CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization:this.testToken
    });
    return this.http.put(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type/', updateSchema, {
      headers,
      observe: 'response',
      responseType: 'text',
    });
  }

  delete_Type(deleteType: string, CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization:this.testToken
    });
    return this.http.delete(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type?Ids=' + deleteType, {
      headers,
      observe: 'response',
      responseType: 'text',
    });
  }

  public get_premisehazardrecords(CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.get<any>(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/', opt);
  }

  public create_premisehazardrecords(
    schema,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    console.log('Create');
    console.log(schema);
    return this.http.post(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/', schema, opt);
  }

  public update_premisehazardrecords(
    schema,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    console.log('Update');
    console.log(schema);
    return this.http.put(
      this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/' + schema.PremiseHazardInfoKey,
      schema,
      opt
    );
  }

  // call geoverfication API
  public call_geoverfication(
    locationinformation: any,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    locationinformation.ForStorage = this.ForStorage;
    locationinformation.MSIProduct = this.MSIProduct;
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.post(
      this._serverBaseUrl + '/' + CustomerId + '/' + AgencyId + '/address/verify',
      // tslint:disable-next-line:arrow-return-shorthand
      locationinformation,
      opt
    );
  }

  // If x and y are null, geocode should be further called
  public geocode(
    locationinformation: any,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    locationinformation.ForStorage = this.ForStorage;
    locationinformation.MSIProduct = this.MSIProduct;
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.post(
      this._serverBaseUrl + '/' + CustomerId + '/' + AgencyId + '/address/geocode',
      locationinformation,
      opt
    );
  }

  public get_defaultproximity(CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.get(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type/default', opt);
  }

  public update_defaultproximity(
    updateDefault,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.put(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type/default', updateDefault, opt);
  }

  // this is first step for uploading file
  public initiateAttachmentUpload(
    attachmentName,
    attachmentDescription,
    size,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    // if (this.Jwthelper.isTokenExpired(localStorage.getItem('access_token'))) {
    //   await this.token.get_token();
    // }

    const opt = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        //  Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
        'x-ccdrive-agency': AgencyId,
        'x-ccdrive-customer': CustomerId,
      }),
    };
    const extension = (attachmentName as string).split('.')[1];
    const fileid = Guid.create() + '.' + extension;
    const attachmentTitle = (attachmentName as string).split('.')[0];
    const body = {
      type: 'File',
      path: '/phz/' + CustomerId + '/' + AgencyId + '/' + fileid,
      metadata: {
        title: attachmentTitle,
        comments: attachmentDescription,
      },
      partition: 'common',
      permission: ['/' + CustomerId + '/' + AgencyId + '/attachment'],
      size_bytes: size,
    };
    return this.http.post(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/ccdrive/initial', body, opt);
  }

  // this is second step for uploading data
  public attachmentUpload(uploadFile, uploadURI, uploadHeadersName, uploadHeadersValue) {
    const opt = {
      headers: new HttpHeaders({}),
    };
    opt.headers = opt.headers.append(uploadHeadersName, uploadHeadersValue);
    console.log(opt.headers);
    return this.http.put(uploadURI, uploadFile, opt);
  }

  // complete upload
  public completeUpload(uploadPath, CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const opt = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        //  Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
        'x-ccdrive-agency': AgencyId,
        'x-ccdrive-customer': CustomerId,
      }),
    };
    const requestbody = {
      items: [
        {
          path: uploadPath,
          version_id: null,
          md5sum: null,
        },
      ],
    };
    console.log(requestbody);
    return this.http.put(
      this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/ccdrive/complete',
      requestbody,
      opt
    );
  }

  // // cancel upload
  // public cancelUpload(cancelPath) {
  //   const opt = {
  //     headers: new HttpHeaders({
  //       Accept: 'application/json',
  //       // Authorization: 'Bearer ' + localStorage.getItem('access_token'),
  //       'Accept-Encoding': 'gzip, deflate',
  //       Connection: 'Keep-Alive',
  //       'Content-Type': 'application/json',
  //       'User-Agent': 'CCDrive',
  //       'x-ccdrive-agency': this.premiseHazardAgencyId,
  //       'x-ccdrive-customer': this.premiseHazardCustomerId
  //     })
  //   };
  //   return this.http.put('https://drive.dev.commandcentral.com/api/v1/items/.cancel?path=' + cancelPath, null, opt);
  // }

  public searchAttachmentByPath(
    fileUploadPath,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    const opt = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        // Authorization: 'Bearer ' + localStorage.getItem('access_token'),

        'Content-Type': 'application/json',
        'x-ccdrive-agency': AgencyId,
        'x-ccdrive-customer': CustomerId,
      }),
    };
    const requestbody = {
      path: fileUploadPath,
      content: true,
    };
    console.log(requestbody);
    console.log(opt);
    return this.http.post(
      this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/ccdrive/search',
      requestbody,
      opt
    );
  }

  public CreatePHZAttachmentRecord(
    newAttachment,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    {
      const opt = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      return this.http.post(
        this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/attachment',
        newAttachment,
        opt
      );
    }
  }

  public CreatePHZTypeAgencyDefault(
    newAgencyDefault,
    CustomerId: string = this.Customer.value,
    AgencyId: string = this.Agency.value
  ) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.post(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/type/default', newAgencyDefault, opt);
  }

  public getallagencies(CustomerId: string = this.Customer.value) {
    // const opt = {
    //   headers: new HttpHeaders({
    //     Authorization:this.testToken
    //   })
    // };
    return this.http.get(this.getagenciesurl + '/' + CustomerId + '/agencies?compact=false&offset=0&limit=-1&order=id');
  }

  public getcutomerKey(CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    return this.http.get(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/');
  }

  // GET tenantSize
  public getTenatSize(tenantId) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.get(this.geobaseURL + 'Phz/tenant/' + tenantId, opt);
  }

  public getPHZRecordsWithKeys(CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value, key) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.get(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/record/key/' + key, opt);
  }
   // given a custoerm, return its tenantID of PHZ service
   public getCustomerTenantId(customerID = this.Customer.value) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
      responseType: 'text' as 'json',
    };
    return this.http.get(this.geobaseURL + 'TenantId/' + customerID + '/GetCustomerTenantId/PremiseHazards', opt);
  }

  public getCustomerList() {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.get(this.geobaseURL + 'TenantId/' + 'GetCustomerIDs/PremiseHazards', opt);
  }

  public submitrecordtobdp(schema, CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization:this.testToken
      }),
    };
    return this.http.post(
      this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/BDP/' + schema.PremiseHazardInfoKey,
      opt,
      { responseType: 'text' }
    );
  }

  public deleterecordfrombdp(schema, CustomerId: string = this.Customer.value, AgencyId: string = this.Agency.value) {
    return this.http.delete(this.geobaseURL + CustomerId + '/' + AgencyId + '/Phz/BDP/' + schema.PremiseHazardInfoKey, {
      responseType: 'text',
    });
  }

  exportData(type: 'type' | 'record'): Observable<void> {
    const endpoint = this.geobaseURL + this.Customer.value + '/' + this.Agency.value + `/Phz/${type}/export`;
    const opt = { responseType: 'blob' as const };
    // tslint:disable-next-line:deprecation
    return this.http.get(endpoint, opt).pipe(
      map((res) => {
        const fileName = `${this.Agency.value}-phz-${type}-export.xlsx`;
        saveAs(res, fileName);
      })
    );
  }

  importData(type: 'type' | 'record', file: File): Observable<ImportResults> {
    const endpoint = this.geobaseURL + this.Customer.value + '/' + this.Agency.value + `/Phz/${type}/import`;
    const formData = new FormData();
    formData.append('File', file, file.name);
    const opt = { responseType: 'json' as const };
    return this.http.post(endpoint, formData, opt).pipe(map((res) => res as ImportResults));
  }
}

export type ImportResults = {
  globalErrors: Array<string>;
  invalidRows: Array<InvalidRow>;
  ignoredRows: Array<IgnoredRow>;
};

export type InvalidRow = {
  sheetName: string;
  rowNumber: number;
  validationFailures: Array<ValidationFailure>;
};

export type IgnoredRow = {
  sheetName: string;
  rowNumber: number;
  error: string;
};

export type ValidationFailure = {
  propertyName: string;
  errorMessage: string;
  attemptedValue: any;
};
